export const apiLink = (path: string) => {
    return "https://www.evil-ark-cluster.com/" + path
}
